import React, { useState } from 'react';
import { FiFileText } from "react-icons/fi";
import { LuActivity, LuBone, LuBrain } from "react-icons/lu";
import './NewAssessment.css'
import OrthoAssessment from './OrthoAssessment';
import NeuroAssessment from './NeuroAssessment';
import GeneralAssessment from './GeneralAssessment';
const NewAssessment = ({ data }) => {
    const [activeTab, setActiveTab] = useState('General');

    const tabs = [
        { id: 'General', label: 'General', icon: LuActivity },
        { id: 'Neuro', label: 'Neuro', icon: LuBrain },
        { id: 'Ortho', label: 'Ortho', icon: LuBone }
    ];

    return (
        <div className="assessment-section">
            <div className="section-title">
                <FiFileText className="header-icon" />
                <h2>New Assessment</h2>
            </div>

            <div className="tab-navigation">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <tab.icon className="tab-icon" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {activeTab === 'Ortho' ? <OrthoAssessment data={data} /> : activeTab === 'Neuro' ? <NeuroAssessment data={data} /> : <GeneralAssessment data={data} />}
        </div>
    );
};

export default NewAssessment;